export default __webpack_public_path__ + "static/exo-v12-latin-900-ef8052b97d5b1904fa413c46aad25e80.woff2";